import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Alert from '../../Alert';
import Skeleton from '@mui/material/Skeleton';
import postAceptarPedido from '../../Queries/postAceptarPedido';
import CircularProgress from '@mui/material/CircularProgress';

//Styles
import styles from './index.module.sass';

export default function ItemOrder({
  screenSize,
  dataDetail = [],
  detailCabecero = [],
  loading,
  setSessionMessage,
  getPedidosCatalogo,
}) {
  const { t } = useTranslation('digitalOrders');
  const [loadingPost, setloadingPost] = useState(false);
  const [open, setopen] = useState(false);
  const [alerText, setalerText] = useState('');
  const tableItemsDetail = t('tableItemsDetail', { returnObjects: true });
  const dataCellWidth = (screenSize === 'phone' && '140px') || `${100 / tableItemsDetail.length}%`;

  function setAltImg(event) {
    event.target.src =
      'https://webimages.terramarbrands.com.mx/shopping-cart/cart-products-gray/preload.jpg';
  }

  const aceptarPedido = useCallback(async () => {
    setloadingPost(true);
    const response = await postAceptarPedido({
      jsonBody: {
        idPedidoAplicar: detailCabecero.idPedido,
        almacen: '02',
        idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
      },
    });

    if (response.message === '498' || response.message === '499') {
      setSessionMessage(response.message);
    } else {
      setopen(true);
      setalerText(t('alert'));
    }
    setloadingPost(false);
  }, [detailCabecero.idPedido, setSessionMessage, t]);

  function realod() {
    getPedidosCatalogo();
  }

  return (
    <div className={`${styles[screenSize]} ${styles.container}`}>
      <Alert
        open={open}
        setOpen={setopen}
        title={t('alertTitle')}
        text={alerText}
        callback={() => {
          realod();
        }}
      />
      {(loading && (
        <div className={styles.table}>
          <Skeleton variant='rectangular' className={styles.loadingText} />
          <Skeleton variant='rectangular' className={styles.loadingText} />
        </div>
      )) || (
        <>
          <div className={`${styles[screenSize]} ${styles.header}`}>
            <div>
              <div className={styles.title}>{t('labelSol')}</div>
              <div>{detailCabecero.nombre}</div>
              <div>
                <span>{t('tel')}</span> {detailCabecero.telefono}
              </div>
              <div>
                <span>{t('mail')}</span> {detailCabecero.correo}
              </div>
              <div>
                {detailCabecero.domicilio.line1} {detailCabecero.domicilio.line2}{' '}
                {detailCabecero.domicilio.line3} &nbsp;{detailCabecero.domicilio.city} &nbsp;
                {detailCabecero.domicilio.postalCode}
              </div>
            </div>
            {screenSize !== 'phone' && (
              <div className={styles.titleRight}>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <div className={styles.titleRight}>{t('resume')}</div>
                <div className={styles.info}>
                  <span>{t('total')}</span> ${detailCabecero.total}
                </div>
                <div className={styles.infoGold}>
                  <span>{t('importe')}</span> ${detailCabecero.total}
                </div>
              </div>
            )}
          </div>

          <div className={styles.content}>
            <div className={styles.table}>
              <div className={styles.tableheader}>
                {tableItemsDetail.map((value, key) => {
                  return (
                    <div key={key} className={styles.text} style={{ width: dataCellWidth }}>
                      {t(value.title)}
                    </div>
                  );
                })}
              </div>
              {dataDetail.map((val, key) => {
                return (
                  <div key={val.idDetallePedidoCatalogo} className={styles.row}>
                    <div className={styles.contentTable}>
                      <div className={`${styles.textContent} `} style={{ width: dataCellWidth }}>
                        <img
                          width='50'
                          height='50'
                          alt=''
                          src={`https://webimages.terramarbrands.com.mx/images-usa/shopping-cart/cart-products/${val.codigo}.jpg`}
                          className={styles.img}
                          onError={setAltImg}
                        />
                      </div>
                      <div className={`${styles.textContent} `} style={{ width: dataCellWidth }}>
                        {val.codigo}
                      </div>
                      <div className={`${styles.textContent} `} style={{ width: dataCellWidth }}>
                        {val.descripcion}
                      </div>
                      <div className={`${styles.textContent} `} style={{ width: dataCellWidth }}>
                        {val.cantidad}
                      </div>
                      <div className={`${styles.textContent} `} style={{ width: dataCellWidth }}>
                        ${val.precio}
                      </div>
                      <div className={`${styles.textContent} `} style={{ width: dataCellWidth }}>
                        ${val.cantidad * val.precio}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {screenSize === 'phone' && (
            <div className={styles.titleRight}>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <div className={styles.titleRight}>{t('resume')}</div>
              <div className={styles.info}>
                <span>{t('total')}</span> $ {detailCabecero.total}
              </div>
              <div className={styles.infoGold}>
                <span>{t('importe')}</span> $ {detailCabecero.total}
              </div>
            </div>
          )}

          <div className={styles.contentButton}>
            {detailCabecero.estatus !== 'Aceptado' ? (
              <div
                className={styles.button}
                onClick={() => {
                  if (!loadingPost) aceptarPedido();
                }}>
                <i className='material-icons-outlined'>shopping_bag</i>
                {(loadingPost && <CircularProgress className={styles.circularProgress} />) ||
                  t('button')}
              </div>
            ) : (
              <div className={styles.infoGold}>{t('buttonAcepted')}&nbsp;</div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
